import React from 'react';

import { Product } from 'src/types';
import {
  NextOrPreviousPayload,
  OpenModalPayload,
  ProductImagesState,
  SetCurrentImagePayload,
} from '../types';
import { MultipleProductImages } from './MultipleProductImages';
import { ProductImageModal } from './ProductImageModal';
import { SingleProductImage } from './SingleProductImage';

export interface ProductImagesCarouselProps {
  product: Product;
  currentImage: ProductImagesState['currentImage'];
  navigatedBy: ProductImagesState['navigatedBy'];
  setCurrentImage: (payload: SetCurrentImagePayload) => void;
  isModalOpen: ProductImagesState['isModalOpen'];
  onOpenModal: (payload: OpenModalPayload) => void;
  onCloseModal: VoidFunction;
  onNextImage: (payload: NextOrPreviousPayload) => void;
  onPrevImage: (payload: NextOrPreviousPayload) => void;
}

export const ProductImagesCarousel = ({
  product,
  currentImage,
  navigatedBy,
  onOpenModal,
  isModalOpen,
  onCloseModal,
  setCurrentImage,
  onNextImage,
  onPrevImage,
}: ProductImagesCarouselProps) => (
  <>
    <ProductImageModal
      product={product}
      images={product.images}
      currentImage={currentImage}
      isModalOpen={isModalOpen}
      closeModal={onCloseModal}
      setCurrentImage={setCurrentImage}
    />
    {product.images.length > 1 ? (
      <MultipleProductImages
        location="Main image"
        setCurrentImage={setCurrentImage}
        onOpenModal={onOpenModal}
        product={product}
        currentImage={currentImage}
        navigatedBy={navigatedBy}
        onNextImage={onNextImage}
        onPrevImage={onPrevImage}
      />
    ) : (
      <SingleProductImage product={product} onOpenModal={onOpenModal} />
    )}
  </>
);
